import { render, staticRenderFns } from "./page18.vue?vue&type=template&id=123790d6&scoped=true&"
import script from "./page18.vue?vue&type=script&lang=js&"
export * from "./page18.vue?vue&type=script&lang=js&"
import style0 from "./page18.vue?vue&type=style&index=0&id=123790d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123790d6",
  null
  
)

export default component.exports